// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__6DM_b","content":"LayoutSettings_content__2Vf5Q"};